import { isValidMobilePhoneWithDDD } from "./phone";

export const dataValidateCreateUser = (data) => {
  const rules = [
    { field: "name", message: "Digite o NOME" },
    { field: "email", message: "Digite o EMAIL" },
    { field: "birthday", message: "Digite a DATA DE NASCIMENTO" },
    { field: "phone", message: "Digite o TELEFONE" },
    { field: "password", message: "Digite a SENHA" },
    { field: "confirmPassword", message: "Digite a CONFIRMAÇÃO da senha" },
  ];

  for (const rule of rules) {
    if (!data?.[rule.field]) {
      return { validData: false, error: rule.message, field: rule.field };
    }
  }

  const email = String(data.email).trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return {
      validData: false,
      error: "Digite um EMAIL válido",
      field: "email",
    };
  }

  if (!isValidMobilePhoneWithDDD(data.phone)) {
    return {
      validData: false,
      error: "Digite um TELEFONE válido no formato (054) 99120-1234",
      field: "phone",
    };
  }

  if (data.password !== data.confirmPassword) {
    return {
      validData: false,
      error: "As senhas não são iguais",
      field: "confirmPassword",
    };
  }

  return { validData: true, error: "Dados Validos" };
};
